import React from 'react';

/**
 * Simple shimmer skeleton placeholders.
 * Replace bare "Loading..." text with these for a polished feel.
 *
 * Usage:
 *   <Skeleton.Block width="60%" height={20} />
 *   <Skeleton.Card />
 *   <Skeleton.Table rows={4} />
 */

const shimmerKeyframes = `
@keyframes skeleton-shimmer {
  0%   { background-position: -400px 0; }
  100% { background-position: 400px 0; }
}
`;

// Inject keyframes once
if (typeof document !== 'undefined' && !document.getElementById('skeleton-style')) {
  const style = document.createElement('style');
  style.id = 'skeleton-style';
  style.textContent = shimmerKeyframes;
  document.head.appendChild(style);
}

const baseStyle = {
  background: 'linear-gradient(90deg, var(--app-surface-soft) 25%, var(--app-border) 50%, var(--app-surface-soft) 75%)',
  backgroundSize: '800px 100%',
  animation: 'skeleton-shimmer 1.4s ease-in-out infinite',
  borderRadius: '10px',
};

function Block({ width = '100%', height = 18, style, ...rest }) {
  return (
    <div
      style={{ ...baseStyle, width, height, ...style }}
      {...rest}
    />
  );
}

function Card({ height = 100 }) {
  return (
    <div
      style={{
        ...baseStyle,
        width: '100%',
        height,
        borderRadius: 'var(--radius-lg)',
      }}
    />
  );
}

function Table({ rows = 3 }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} style={{ display: 'flex', gap: 16 }}>
          <Block width="30%" height={16} />
          <Block width="40%" height={16} />
          <Block width="30%" height={16} />
        </div>
      ))}
    </div>
  );
}

export const Skeleton = { Block, Card, Table };
